import {
  checkAndroidAppSource,
  checkAndroidWebView,
} from 'modules/missions/helpers/appDetection';
import { getAppSource } from './appSource';

export const isOAuthUnsupported = (): boolean =>
  checkAndroidWebView() || checkAndroidAppSource(getAppSource());
